import React from 'react';
import { CenteredAlignedContainerV2 } from '../../../../layout/Container';
import {
  useGetLoggedUserQuery,
  useGetSupplierQuery,
} from '@syncfab/machine';
import SupplierFormShell from '../SupplierFormShell';
import CertificationsForm from '../CertificationsForm';
const CertificationsIndex = () => {
  // const loggedUser = useAppSelector(state => state.user.loggedUser);
  const { data: loggedUser } = useGetLoggedUserQuery();
  const { data: supplier } = useGetSupplierQuery(loggedUser?.supplierId ?? '', {
    skip: !loggedUser,
  });

  return (
    <CenteredAlignedContainerV2>
      {!!supplier && (
        <SupplierFormShell
          activeStep={4}
          supplier={supplier}
        >
          <CertificationsForm />
        </SupplierFormShell>
      )}
    </CenteredAlignedContainerV2>
  );
};

export default CertificationsIndex;
